import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import type { FetchPartnerConfigurationsByIdRequest } from '../../dto/partner-configuration-dto';
import { FetchPartnerConfigurationsByIdResponse } from '../../dto/partner-configuration-dto';

type FetchPartnerConfigurationOptions = Partial<
  Omit<IHttpRequest<void>, 'body'>
> & {
  httpCall?: IHttpCall;
};

export function fetchPartnerConfigurationById(
  baseUrl: string,
  payload: FetchPartnerConfigurationsByIdRequest,
  options?: FetchPartnerConfigurationOptions,
): Promise<IHttpResponse<FetchPartnerConfigurationsByIdResponse>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<FetchPartnerConfigurationsByIdRequest> = {
    url: `${baseUrl}/api/v1/partner-configurations/${payload.partnerId}/`,
    method: 'GET',
    headers,
    queryParams: {
      ...payload,
    },
    schemas: {
      response: FetchPartnerConfigurationsByIdResponse,
    },
    ...restOptions,
  };

  return httpCall(request);
}
